import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import { Refresh } from '@mui/icons-material';

export default function TokenExpiryDialog({ open, onRefresh }) {
  return (
    <Dialog
      open={open}
      maxWidth="sm"
      fullWidth
      disableEscapeKeyDown
      onClose={(event, reason) => {
        // Prevent closing on backdrop click or escape key
        if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
          return;
        }
      }}
    >
      <DialogTitle>
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          width={'100%'}
        >
          <Typography
            color="grey.900"
            variant="body2"
            component="span"
            fontSize={16}
            fontWeight={600}
          >
            Session Expired
          </Typography>
        </Box>
      </DialogTitle>

      <DialogContent
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
        }}
      >
        <Typography color={'text.primary'} variant="body2" fontSize={14}>
          Your session has expired. Please click the refresh button below to
          refresh your session and continue.
        </Typography>
      </DialogContent>

      <DialogActions sx={{ padding: '16px 22px' }}>
        <Button
          variant="contained"
          startIcon={<Refresh />}
          onClick={onRefresh}
          sx={{
            textTransform: 'none',
            fontWeight: 500,
          }}
        >
          Refresh Session
        </Button>
      </DialogActions>
    </Dialog>
  );
}
